import { useEffect } from "react";

// Adds <meta name="robots" content="noindex,nofollow"> while mounted.
// Used on hidden-but-routed pages (e.g. /au) per spec §6.
export default function NoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "robots");
    meta.setAttribute("content", "noindex,nofollow");
    meta.setAttribute("data-continuum-noindex", "1");
    document.head.appendChild(meta);
    return () => {
      // Remove any robots meta we added (covers StrictMode double-invoke).
      document.head
        .querySelectorAll('meta[name="robots"][data-continuum-noindex="1"]')
        .forEach((m) => m.remove());
    };
  }, []);
  return null;
}
